import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import { size , isArray } from 'lodash'
import OrderCardCustomer from './OrderCardCustomer'
import OrderCardMetadata from './OrderCardMetadata'
import OrderCardShipping from './OrderCardShipping'
import OrderCardDelivery from './OrderCardDelivery'

const noop = () => (null)
class OrderCardsResume extends React.Component {
  _cards = (data) => {
    return [
      OrderCardCustomer(data),
      OrderCardMetadata(data),
      OrderCardShipping(data),
      OrderCardDelivery(data)
    ]
  }

  renderResumeInfo = (fields = []) => {
    return fields.map(({ title, value }, index) => (
      <Row type='flex' justify='space-between' key={index}>
        <Col span={12} > <h4 style={{ fontWeight: 'bold', color: '#848484', textTransform: 'capitalize' }} >{title}</h4></Col>
        <Col span={12}>{typeof value === 'function' ? value() : value}</Col>
      </Row>
    ))
  }

  _renderCard = ({ title = noop, subtitle = noop, info = [], extra = noop, footer, extra_info = [] }, index) => {
    return (
      <Col {...{ xs: 24, sm: 24, lg: 6, md: 12 }} key={index}>
        <div className='box bordered padding-box' style={{ minHeight: 300 }}>
          <Row className='order-resume-title' type='flex' justify='space-between'>
            <Col span={18}> {typeof value === 'function' ? title() : title} </Col>
            <Col span={6}> {typeof value === 'function' ? extra() : extra} </Col>
          </Row>
          <Row className='order-resume-subtitle'>
            <Col > {subtitle()} </Col>
          </Row>
          <Row className='border-top'>
            {isArray(info) ? this.renderResumeInfo(info) : info()}
          </Row>
          {size(extra_info) > 0 && (
            <Row className='border-top'>
              {this.renderResumeInfo(extra_info)}
            </Row>
          )}
          {
            typeof footer === 'function' && footer() && (
              <Row className=''>
                {footer()}
              </Row>
            )
          }
        </div>
      </Col>
    )
  }
  render () {
    const { data } = this.props
    return (
      <Row gutter={16}>
        {this._cards(data).map(this._renderCard)}
      </Row>
    )
  }
}

OrderCardsResume.propTypes = {
  data: PropTypes.array
}

export default OrderCardsResume
